module.exports = __webpack_public_path__ + "img/57_6.b427432b.png";